@if (isLightBoxOpen) {
    <section animate.enter="fade-in" animate.leave="fade-out" class="light-box relative">
        <section [ngClass]="{ 'fit relative': isCloseIcomInside }">
            @if (isCloseIcon) {
                <button
                    type="button"
                    [ngClass]="{ 'inside-mode': isCloseIcomInside }"
                    (click)="util.stopAndPrevent($event); closeLightBox.emit()"
                    class="close-icon pointer"
                    aria-label="Close"
                >
                    <span class="mat-icon" aria-hidden="true">close</span>
                </button>
            }
            <ng-content></ng-content>
        </section>
    </section>
}
